export default __webpack_public_path__ + "static/media/addPhotoIcon.2a053cbb.svg";